import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface Props extends WithStyles<typeof styles> {
	index: number;
}

const Component = (props: Props) => {
	const { classes = {}, index } = props;
	return (
		<div className={classes.pin}>
			{index + 1}
		</div>
	);
};

export const LocationIcon = withStyles(Component, styles);
